import { httpGet, httpPost } from "@bilibili/growup-utils/_esm5/http";

import { ACTIVITY_ID } from "@/consts";

export const apiPrefix =
  location.host.indexOf("bilibili.com") === -1
    ? `${location.protocol}//${location.hostname}/api/x/fission`
    : `${location.protocol}//api.bilibili.com/x/fission`;
type IHTTPResponse<T> = {
  code: number;
  message: string;
  ttl: number;
  data?: T;
};

const defatultReqParamas = (obj) => {
  return Object.assign({}, obj, { platform: "android", buvid: "123" });
};

type HTTPromiseRes<T = {}> = Promise<IHTTPResponse<T>>;
export interface Info {
  activity_status: number;
  num: number;
  num_str: string;
  head_pic: string;
  explain_pic: string;
  awards_pic: string;
  has_reward: boolean;
  activity: string;
  activity_details: string;
  share_title: string;
  share_content: string;
  share_url: string;
  share_img: string;
}

export function getShareUrl(): HTTPromiseRes<{ url: string }> {
  return httpGet(`${apiPrefix}/share/url`, {
    query: { activity_uid: ACTIVITY_ID }
  });
}

export function getCipher(
  activity_uid: string,
  token: string
): HTTPromiseRes<{ watchword: string; watchword_desc: string }> {
  return httpPost(`${apiPrefix}/share/watchword/out`, { data: { activity_uid, token }, hideError: true });
}

export function getShareToken(): HTTPromiseRes<{ token: string }> {
  return httpPost(`${apiPrefix}/share/token`, {
    data: { activity_uid: ACTIVITY_ID }
  });
}

export function getOnlineRes(watchword: string) {
  return httpGet(`${apiPrefix}/cheers/result/online`, { query: { watchword, activity_uid: ACTIVITY_ID } });
}

export function getOnlineInviteeInfo(token: string) {
  return httpGet(`${apiPrefix}/cheers/info/online`, { query: { token, activity_uid: ACTIVITY_ID }, hideError: true });
}

export function getBanner() {
  return httpGet(`${apiPrefix}/banner`, { query: { activity_uid: ACTIVITY_ID }, hideError: true });
}

export function finishTask(task_uniq_id: number, task_id: number, timestamp: number = 0, sign: string = "") {
  return httpPost(`${apiPrefix}/cheers/task/finish`, {
    data: { activity_uid: ACTIVITY_ID, task_uniq_id, task_id, timestamp, sign },
    hideError: true
  });
}

export function draw(task_uniq_id: number, task_id: number) {
  return httpPost(`${apiPrefix}/cheers/task/lottery`, {
    data: { activity_uid: ACTIVITY_ID, task_uniq_id, task_id }
  });
}

export function getSingleRes() {
  return httpGet(`${apiPrefix}/cheers/result/single`, { query: { activity_uid: ACTIVITY_ID } });
}

export function getInfo() {
  return httpGet(`${apiPrefix}/cheers/info`, { query: { activity_uid: ACTIVITY_ID }, hideError: true });
}

export function awardList(): HTTPromiseRes<any> {
  return httpGet(`${apiPrefix}/cheers/award/list`, { query: { activity_uid: ACTIVITY_ID } });
}

export function shake(near_by: string): HTTPromiseRes<any> {
  return httpPost(`${apiPrefix}/cheers/do`, { data: { near_by, activity_uid: ACTIVITY_ID } });
}

export function getResult(): HTTPromiseRes<any> {
  return httpGet(`${apiPrefix}/cheers/result`, { query: { activity_uid: ACTIVITY_ID } });
}

export function getPic() {
  return httpGet(`${apiPrefix}/cheers/placard`, {
    query: defatultReqParamas({ activity_uid: ACTIVITY_ID }),
    hideError: true
  });
}
export function getMyPlacards({ pn, ps }: { pn: number; ps: number }): HTTPromiseRes<any> {
  return httpGet(`${apiPrefix}/cheers/my/placard`, { query: { activity_uid: ACTIVITY_ID, pn, ps }, hideError: true });
}

export function getMyCards(): HTTPromiseRes<any> {
  return httpGet(`${apiPrefix}/cheers/my/card`, { query: { activity_uid: ACTIVITY_ID }, hideError: true });
}

export function getShareChannels(share_id: string, share_origin: string, oid: string) {
  return httpGet(`${location.protocol}//api.bilibili.com/x/share/channels`, {
    query: { share_id, share_origin, oid },
    hideError: true
  });
}

export function postOpenPacket(): HTTPromiseRes<any> {
  return httpPost(`${apiPrefix}/cheers/redpack`, { data: { activity_uid: ACTIVITY_ID }, hideError: true });
}

export function clickShare(opt: { share_id: string; oid: string; share_origin: string }) {
  return httpPost(`${location.protocol}//api.bilibili.com/x/share/click`, {
    data: opt,
    hideError: true
  });
}
